import React, {useState} from 'react';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import {NotificationManager} from "react-notifications";

const CropImage = ({
                       aspectRatio,
                       stateSetImage,
                       setLocal,
                       setError,
                       imageLocation,
                       maxSizeInKB = 400,
                       sizeErrorMessage
                   }) => {
    const [crop, setCrop] = useState({unit: '%', width: 30, aspect: aspectRatio});
    const [modalImage, setModalImage] = useState(null);
    const [modalToggle, setModalToggle] = useState(false);

    const toggleRightModal = () => {
        setModalToggle(!modalToggle);

    };


    const cropRightImage = async () => {
        const image = new Image();
        image.src = modalImage;
        const croppedImageUrl = await getCroppedImg(image, crop);


        setLocal(croppedImageUrl);
        toggleRightModal();
        setModalImage(null);
    };

    const getCroppedImg = (image, crop) => {


        const canvas = document.createElement('canvas');

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        stateSetImage(canvas.toDataURL('image/png'));
        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {

                if (!blob) {
                    reject(new Error('Canvas is empty'));
                    return;
                }
                blob.name = 'newFile.png';
                window.URL.revokeObjectURL(image.src);
                resolve(window.URL.createObjectURL(blob));
            }, 'image/png');
        });
    }

    const getDefaultCrop = (imageWidth, imageHeight, aspectRatio) => {
        console.log(aspectRatio, imageHeight, imageWidth);
        let cropWidth, cropHeight;

        if (imageWidth / aspectRatio < imageHeight) {
            // If the maximum width with the given aspect fits inside the image
            cropWidth = imageWidth;
            cropHeight = imageWidth / aspectRatio;
        } else {
            // If the maximum height with the given aspect fits inside the image
            cropHeight = imageHeight;
            cropWidth = imageHeight * aspectRatio;
        }

        // Center the crop area
        const x = (imageWidth - cropWidth) / 2;
        const y = (imageHeight - cropHeight) / 2;

        console.log({
            x: x,
            y: y,
            width: cropWidth,
            height: cropHeight,
            unit: "px"
        });
        return {
            x: x,
            y: y,
            width: cropWidth,
            height: cropHeight,
            unit: "px"
        };
    };

    return (
        <div>
            <input
                accept="image/png, image/jpeg"
                className="d-none"
                type="file"
                id="formFile"
                onClick={(e) => {
                    e.target.value = null;
                    setError(null);

                }}
                onChange={(e) => {


                    if (e.target.files[0].size <= maxSizeInKB * 1024) {
                        if (e.target.files && e.target.files.length > 0) {
                            setCrop(undefined) // Makes crop preview update between images.
                            const reader = new FileReader()
                            reader.addEventListener('load', () => {
                                    let image = new Image();
                                    image.src = reader.result;

                                    image.onload = () => {
                                        let canvas = document.createElement("canvas");
                                        let ctx = canvas.getContext("2d");
                                        let maxWidth = 300;
                                        let maxHeight = 300;
                                        let width = image.width;
                                        let height = image.height;
                                        if (width > height) {
                                            if (width > maxWidth) {
                                                height *= maxWidth / width;
                                                width = maxWidth;
                                            }
                                        } else {
                                            if (height > maxHeight) {
                                                width *= maxHeight / height;
                                                height = maxHeight;
                                            }
                                        }
                                        canvas.width = width;
                                        canvas.height = height;
                                        ctx.drawImage(image, 0, 0, width, height);
                                        let dataUrl = canvas.toDataURL("image/png");
                                        setModalImage(dataUrl);
                                        const defaultCrop = getDefaultCrop(canvas.width, canvas.height, aspectRatio);
                                        console.log(defaultCrop, "Default Crop");
                                        setCrop(defaultCrop);
                                    }
                                    // setModalImage(reader.result?.toString() || '')
                                }
                            )
                            reader.readAsDataURL(e.target.files[0])
                        }
                        // setModalImage(e.target.files[0]);
                        toggleRightModal();
                    } else {
                        // setImageError("right");
                        setError(imageLocation);
                        const errorMsg = sizeErrorMessage || "Image size exceeds the maximum allowed size!";
                        NotificationManager.error(errorMsg);

                    }
                }}
                name="uploadFile"
            />
            <Modal isOpen={modalToggle} toggle={toggleRightModal} backdrop={false}>
                <ModalHeader>Crop Image</ModalHeader>
                <ModalBody className="text-center modalBg">
                    <p className="text-start">Please select the image area you want to show in the logo</p>
                    {modalImage && (
                        <ReactCrop
                            aspect={aspectRatio}
                            crop={crop}
                            onChange={(newCrop) => setCrop(newCrop)}
                        >
                            <img src={modalToggle ? modalImage : ""} alt=""/>
                        </ReactCrop>
                    )}
                    <div className="d-flex justify-content-start mt-3">
                        <Button className="btn-success w-50" onClick={cropRightImage}>
                            Save
                        </Button>
                        <Button className="btn-danger mx-3 w-50" type="button" onClick={toggleRightModal}>
                            Cancel
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default CropImage;
